export const doesFieldHaveFocus = (name: string): boolean =>
    document.hasFocus() &&
    !!document.activeElement &&
    !!document.activeElement.attributes[0] &&
    name === document.activeElement.attributes[0].name

export const isCountryUS = (value: any): boolean => value === '840' || value === 840
export const isCountryCAN = (value: any): boolean => value === '124' || value === 124
export const isUSorCanada = (value: any): boolean => isCountryUS(value) || isCountryCAN(value)

export const isPhoneCodeUS = (value: any): boolean => value === '1' || value === 1

// Post Codes Are Required For The Following Countries In Trulioo
// South Africa, Germany, UK, Mexico, Japan, Canada, United States
export const isPostcodeRequiredCountry = (countryId: number | string) =>
    [710, 276, 826, 484, 392, 124, 840].includes(+countryId)

export const determineChangeValue = (value: any) => {
    if (value) {
        if (!Array.isArray(value)) {
            return value.value
        } else {
            return value[0].value
        }
    }
    return value
}
